"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInjectStore = void 0;
var _inject = require("../redux/inject");
var _redux = require("redux");
/**
 * Hook injection package store to global store.
 * @category Hooks
 * @example
 * // Example of a redux package inject.
 *
 * useInjectStore({ key: packageKey, reducer: { ...packageReducers }, packageSaga })
 *
 * @param {string} key, Name of package.
 * @param {Object} reducer, Object with reducers from package.
 * @param {function} saga, Saga from package.
 */

const useInjectStore = _ref => {
  let {
    key = '',
    reducer = {},
    saga
  } = _ref;
  (0, _inject.useInjectReducer)({
    key,
    reducer: (0, _redux.combineReducers)(reducer)
  });
  (0, _inject.useInjectSaga)({
    key,
    saga
  });
};
exports.useInjectStore = useInjectStore;